import "../styles/Play.scss";
import {Chat} from "../services/chat";
import {useLocation, useNavigate} from "react-router-dom";
import {path} from "src/router/path";
import {getArtistFromPath} from "src/utils/artist.utils";

const Play = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const artist = getArtistFromPath(location.pathname);

  const handleBack = () => {
    navigate(path.character(artist));
  };

  const handleExpire = () => {
    navigate(path.expired(artist));
  };

  return (
    <div className="play-container">
      <Chat artist={artist} onBack={handleBack} onExpire={handleExpire} />
    </div>
  );
};

export default Play;
